import React from 'react';
import { useIntl } from 'react-intl';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import Button from '@ts-core/components/Button';

export interface ConfirmDialogProps {
  open: boolean;

  title?: React.ReactNode;
  message?: React.ReactNode;

  confirmActionTitle?: React.ReactNode;
  cancelActionTitle?: React.ReactNode;

  onCancel?: () => void;
  onConfirm?: () => void;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const intl = useIntl();
  const {
    open,
    title,
    message,
    confirmActionTitle = 'Ok',
    cancelActionTitle = intl.formatMessage({ id: 'button.cancel' }),
    onCancel,
    onConfirm,
  } = props;

  return (
    <Dialog open={open} keepMounted onClose={onCancel} aria-labelledby="confirm-alert-title" aria-describedby="confirm-alert-description">
      {title && <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>}
      {message && (
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{message}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelActionTitle}
        </Button>
        {onConfirm && (
          <Button onClick={onConfirm} color="primary">
            {confirmActionTitle}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
